import { track } from "./index.js";
/**
 * @internal
 */
export async function trackConnect(args) {
    const { client, ecosystem, walletType, walletAddress, chainId } = args;
    return track({
        client,
        ecosystem,
        data: {
            source: "connectWallet",
            action: "connect",
            walletType,
            walletAddress,
            chainId,
        },
    });
}
//# sourceMappingURL=connect.js.map